import React, { Component } from "react";
import { Link } from "gatsby";

import GoogleCaptcha from "components/Captcha/Captcha";
import "./BusinessForm.css";

const validPhoneRegex = new RegExp(/^[0-9]{10}$/);
const validWebsiteUrlRegex = new RegExp(
    /^((https|http):\/\/)?(www\.)?([a-zA-Z0-9-]{1,63})(\.[a-zA-Z0-9]{1,63})+$/
);
const websiteRegexWithPath = new RegExp(
    /^((https|http):\/\/)?(www\.)?([a-zA-Z0-9-]{1,63})(\.[a-zA-Z0-9]{1,63})+([:?#/].*)+$/
);
const validEmailRegex = new RegExp(
    /^[A-Za-z0-9_\-+.$/]+@[A-Za-z0-9]+(\.[A-Za-z0-9]+)+$/
);
const validOTPRegex = new RegExp(/^[0-9]{5}$/);
const backendURL = "/webapi/lead-form";

class BusinessForm extends Component {
    constructor() {
        super();
        this.GoogleCaptchaRef = React.createRef();
        this.integrationDrop = false;
        this.state = {
            businessName: "",
            solPaymentStore: false,
            solPaymentWebsite: false,
            solSwitch: false,
            solAdvt: false,
            solCount: 0,
            natureGrocery: false,
            natureFashion: false,
            natureFood: false,
            natureHealth: false,
            natureEntertain: false,
            natureTravel: false,
            natureOthers: false,
            natureCount: 0,
            physicalStore: false,
            numberOfStore: "",
            website: "",
            ordersPerMonth: "",
            integrationPlatforms: [],
            brandAds: false,
            rewardCoupons: false,
            name: "",
            emailId: "",
            phoneNumber: "",
            captcha: "",
            captchaState: "", // set this before calling captcha, after verification it is used in captchaVerifyCallback to determine where to go next
            otp: "",
            otpState: "hidden", // hidden, sendOTP, enterOTP, correctOTP, errorOTP
            otpToken: "",
            tnc: "",
            formClass: "", // success, error
            formMsg: "",
            dialogActive: false,
            hideSubmit: false,
            submitSpin: false, // spinner inside submit btn
            errors: {
                businessName: "",
                businessSolution: "",
                businessNature: "",
                physicalStore: "",
                numberOfStore: "",
                website: "",
                ordersPerMonth: "",
                integrationPlatforms: "",
                brandAds: "",
                rewardCoupons: "",
                name: "",
                emailId: "",
                phoneNumber: "",
                captcha: "",
                otp: "",
                tnc: "",
            },
        };
    }

    componentDidMount() {
        if (typeof document !== "undefined") {
            document.addEventListener("click", this.clickEvent);
        }
    }

    componentWillUnmount() {
        if (typeof document !== "undefined") {
            document.removeEventListener("click", this.clickEvent);
        }
    }

    // Setting Captcha value
    captchaVerifyCallback = captcha => {
        // control flow with captcha token
        this.setState(
            {
                captcha: captcha,
                errors: {
                    ...this.state.errors,
                    captcha: "",
                },
            },
            () => {
                switch (this.state.captchaState) {
                    case "sendOTP":
                        this.sendOTP();
                        break;
                    case "resendOTP":
                        this.sendOTP(true);
                        break;
                    case "submitForm":
                        this.submitForm();
                        break;
                    default:
                        break;
                }
            }
        );
    };

    captchaExpiredCallback = () => {
        this.setState({
            captcha: "",
            errors: {
                ...this.state.errors,
                captcha: "",
            },
        });
        this.GoogleCaptchaRef.current.ResetCaptcha();
    };

    // Validating the form before submission - checking if error exists
    validateForm = errors => {
        let valid = true;
        Object.values(errors).forEach(val => val.length > 0 && (valid = false));
        return valid;
    };

    sendOTP = (resend = false) => {
        const phoneNumber = this.state.phoneNumber;
        if (validPhoneRegex.test(phoneNumber)) {
            if (
                this.state.captchaState !== "sendOTP" &&
                this.state.captchaState !== "resendOTP"
            ) {
                this.setState(
                    {
                        otp: "",
                        otpState: resend ? "resendOTP" : "hidden",
                        captcha: "",
                        captchaState: resend ? "resendOTP" : "sendOTP",
                        submitSpin: !resend,
                        formMsg: "",
                    },
                    this.GoogleCaptchaRef.current.execute
                );
            } else {
                this.setState({ captchaState: "", formMsg: "" }, () => {
                    fetch(`${backendURL}/sendOTP`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                        },
                        body: JSON.stringify({
                            number: phoneNumber,
                            captcha: this.state.captcha,
                            fingerprint: window.fingerprint,
                        }),
                    })
                        .then(res => {
                            return res.json();
                        })
                        .then(res => {
                            if (res.status === "ok") {
                                this.setState({
                                    otpToken: res.otpToken,
                                    otpState: "enterOTP",
                                    submitSpin: false,
                                });
                            } else if (res.status === "invalid captcha") {
                                this.setState(
                                    {
                                        captcha: "",
                                        captchaState: "sendOTP",
                                        submitSpin: !resend,
                                    },
                                    this.GoogleCaptchaRef.current.execute
                                );
                            } else if (res.status === "invalid number") {
                                this.setState({
                                    otp: "",
                                    otpState: "hidden",
                                    submitSpin: false,
                                    errors: {
                                        ...this.state.errors,
                                        otp: "",
                                        phoneNumber:
                                            "Please enter valid phone number",
                                    },
                                });
                            } else if (res.status === "blocked") {
                                this.setState(
                                    {
                                        otp: "",
                                        otpState: "hidden",
                                        submitSpin: false,
                                    },
                                    () => {
                                        this.showFormResponse(
                                            false,
                                            "Blocked or too many attempts! Try again after some time."
                                        );
                                    }
                                );
                            } else {
                                this.setState(
                                    {
                                        otp: "",
                                        otpState: "hidden",
                                        submitSpin: false,
                                    },
                                    () => {
                                        this.showFormResponse(false);
                                    }
                                );
                            }
                        })
                        .catch(err => {
                            this.setState(
                                {
                                    otp: "",
                                    otpState: "hidden",
                                    submitSpin: false,
                                },
                                () => {
                                    this.showFormResponse(
                                        false,
                                        "Something went wrong! Please try again after some time."
                                    );
                                }
                            );
                        });
                });
            }
        } else {
            this.setState({
                errors: {
                    ...this.state.errors,
                    phoneNumber: "Please enter valid phone number",
                },
            });
        }
    };

    resendOTP = () => {
        this.setState(
            {
                otp: "",
                otpToken: "",
                otpState: "resendOTP",
                captcha: "",
                captchaState: "",
                errors: {
                    ...this.state.errors,
                    otp: "",
                    captcha: "",
                },
            },
            () => {
                this.sendOTP(true);
            }
        );
    };

    handleChange = e => {
        let target = e.target;
        let name = target.name;
        let value = target.type === "checkbox" ? target.checked : target.value;
        let lstate = this.state;
        let errors = lstate.errors;

        switch (name) {
            case "businessName":
                errors.businessName =
                    value.length > 0 ? "" : "Business name should not be empty";
                break;
            case "name":
                errors.name =
                    value.length > 0 ? "" : "Name should not be empty";
                break;
            case "ordersPerMonth":
                errors.ordersPerMonth =
                    value.length > 0 ? "" : "Please select orders value";
                break;
            case "brandAds":
            case "rewardCoupons":
                break;
            case "physicalStore":
                lstate.numberOfStore = "";
                errors.numberOfStore = "";
                break;
            case "numberOfStore":
                errors.numberOfStore =
                    value.length > 0 ? "" : "Please select number of stores";
                break;
            case "website":
                errors.website =
                    value.length === 0 || validWebsiteUrlRegex.test(value)
                        ? ""
                        : websiteRegexWithPath.test(value)
                        ? "Plase insert only domain (e.g. phonepe.com)"
                        : "Website url is not valid";
                break;
            case "emailId":
                errors.emailId =
                    value.length === 0
                        ? "Email ID should not be empty"
                        : validEmailRegex.test(value)
                        ? ""
                        : "Please enter valid email id";
                break;
            case "phoneNumber":
                lstate.otp = "";
                lstate.otpState = "hidden";
                lstate.captcha = "";
                lstate.captchaState = "";
                errors.captcha = "";
                errors.otp = "";
                value = value.replace(/\D/g, "");
                if (value.length > 10) value = value.substr(0, 10);
                if (validPhoneRegex.test(value) || value.length === 0) {
                    errors.phoneNumber = "";
                } else {
                    errors.phoneNumber = "Please enter valid phone number";
                }
                break;
            case "solPaymentWebsite":
                errors.integrationPlatforms = "";
                lstate.integrationPlatforms = [];
            // falls through
            case "solPaymentStore":
            case "solSwitch":
            case "solAdvt":
                value === true ? lstate.solCount++ : lstate.solCount--;
                errors.businessSolution =
                    lstate.solCount > 0
                        ? ""
                        : "Please select at least one business solution";
                break;
            case "natureGrocery":
            case "natureFashion":
            case "natureFood":
            case "natureHealth":
            case "natureEntertain":
            case "natureTravel":
            case "natureOthers":
                value === true ? lstate.natureCount++ : lstate.natureCount--;
                errors.businessNature =
                    lstate.natureCount > 0
                        ? ""
                        : "Please select all that apply to your business";
                break;
            case "otp":
                value = value.replace(/\D/g, "");
                errors.otp = "";
                break;
            case "tnc":
                errors.tnc =
                    value === true
                        ? ""
                        : "Please agree to the Terms & Conditions";
                break;
            default:
                break;
        }

        lstate[name] = value;
        lstate.hideSubmit = false;
        if (this.validateForm(errors)) lstate.formMsg = "";
        else {
            lstate.formMsg = "Please correct form errors";
            lstate.formClass = "error";
        }
        this.setState({ ...lstate, errors });
    };

    handleSubmit = e => {
        if (e && e.preventDefault) e.preventDefault();
        const otpState = this.state.otpState;
        if (otpState === "enterOTP") this.submitForm();
        else this.sendOTP();
    };

    submitForm = () => {
        let errors = this.state.errors;
        let stateObj = this.state;
        // Value check before submission
        errors.businessName =
            stateObj.businessName.length > 0
                ? ""
                : "Business name should not be empty";
        errors.name =
            stateObj.name.length > 0 ? "" : "Name should not be empty";
        errors.ordersPerMonth =
            stateObj.ordersPerMonth.length > 0 ? "" : "Please select orders";
        if (stateObj.physicalStore) {
            errors.numberOfStore =
                stateObj.numberOfStore.length > 0
                    ? ""
                    : "Please select number of stores";
        } else {
            stateObj.numberOfStore = "";
            errors.numberOfStore = "";
        }
        if (stateObj.solPaymentWebsite) {
            errors.integrationPlatforms =
                stateObj.integrationPlatforms.length > 0
                    ? ""
                    : "Please select integration platforms";
        } else {
            stateObj.integrationPlatforms = [];
            errors.integrationPlatforms = "";
        }
        errors.website =
            stateObj.website.length === 0 ||
            validWebsiteUrlRegex.test(stateObj.website)
                ? ""
                : websiteRegexWithPath.test(stateObj.website)
                ? "Plase insert only domain (e.g. phonepe.com)"
                : "Website url is not valid";
        errors.emailId =
            stateObj.emailId.length === 0
                ? "Email ID should not be empty"
                : validEmailRegex.test(stateObj.emailId)
                ? ""
                : "Please enter valid email id";
        if (
            stateObj.phoneNumber.length === 0 ||
            !validPhoneRegex.test(stateObj.phoneNumber)
        ) {
            errors.phoneNumber = "Please enter valid phone number";
        }
        errors.otp = validOTPRegex.test(stateObj.otp) ? "" : "Invalid OTP";
        errors.businessSolution =
            stateObj.solCount > 0
                ? ""
                : "Please select at least one business solution";
        errors.businessNature =
            stateObj.natureCount > 0
                ? ""
                : "Please select all that apply to your business";
        errors.tnc =
            stateObj.tnc === true
                ? ""
                : "Please agree to the Terms & Conditions";

        this.setState({ formMsg: "", errors }, () => {
            if (this.validateForm(errors)) {
                const state = this.state;
                const {
                    businessName,
                    physicalStore,
                    numberOfStore,
                    ordersPerMonth,
                    integrationPlatforms,
                    brandAds,
                    rewardCoupons,
                    website,
                    name,
                    emailId,
                    phoneNumber,
                    solPaymentStore,
                    solPaymentWebsite,
                    solSwitch,
                    solAdvt,
                    natureGrocery,
                    natureFashion,
                    natureFood,
                    natureHealth,
                    natureEntertain,
                    natureTravel,
                    natureOthers,
                    otp,
                    otpToken,
                    tnc,
                    captcha,
                } = state;
                const data = {
                    businessName,
                    solPaymentStore: solPaymentStore ? 1 : 0,
                    solPaymentWebsite: solPaymentWebsite ? 1 : 0,
                    solSwitch: solSwitch ? 1 : 0,
                    solAdvt: solAdvt ? 1 : 0,
                    natureGrocery: natureGrocery ? 1 : 0,
                    natureFashion: natureFashion ? 1 : 0,
                    natureFood: natureFood ? 1 : 0,
                    natureHealth: natureHealth ? 1 : 0,
                    natureEntertain: natureEntertain ? 1 : 0,
                    natureTravel: natureTravel ? 1 : 0,
                    natureOthers: natureOthers ? 1 : 0,
                    physicalStore: physicalStore ? 1 : 0,
                    numberOfStore,
                    ordersPerMonth,
                    integrationPlatforms,
                    brandAds: brandAds ? 1 : 0,
                    rewardCoupons: rewardCoupons ? 1 : 0,
                    website,
                    name,
                    emailId,
                    phoneNumber,
                    otp,
                    otpToken,
                    tnc: tnc ? 1 : 0,
                    captcha,
                    fingerprint: window.fingerprint,
                };

                // verify captcha
                if (state.captchaState !== "submitForm") {
                    this.setState(
                        {
                            captcha: "",
                            captchaState: "submitForm",
                            submitSpin: true,
                        },
                        this.GoogleCaptchaRef.current.execute
                    );
                } else {
                    this.setState({ captchaState: "" }, () => {
                        // submit data to backend
                        fetch(backendURL + "/submitForm", {
                            method: "POST",
                            headers: {
                                "X-APP-ID": "PhonePe Business Registration",
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                            },
                            body: JSON.stringify(data),
                        })
                            .then(res => {
                                return res.json();
                            })
                            .then(res => {
                                if (res.status === "ok") {
                                    this.setState({
                                        otpState: "hidden",
                                    });
                                    this.showFormResponse(true);
                                } else if (res.status === "invalid captcha") {
                                    this.setState(
                                        {
                                            captcha: "",
                                            captchaState: "submitForm",
                                        },
                                        this.GoogleCaptchaRef.current.execute
                                    );
                                } else if (res.status === "blocked") {
                                    this.showFormResponse(
                                        false,
                                        "Blocked or too many attempts! Try again after some time."
                                    );
                                } else if (res.status === "invalid data") {
                                    this.showFormResponse(
                                        false,
                                        "Please correct form errors"
                                    );
                                } else if (res.status === "invalid number") {
                                    this.setState(
                                        {
                                            otp: "",
                                            otpState: "hidden",
                                            errors: {
                                                ...this.state.errors,
                                                otp: "",
                                                phoneNumber:
                                                    "Please enter valid phone number",
                                            },
                                        },
                                        () => {
                                            this.showFormResponse(
                                                false,
                                                "Please correct form errors"
                                            );
                                        }
                                    );
                                } else if (res.status === "invalid OTP") {
                                    this.setState(
                                        {
                                            otpState: "enterOTP",
                                            errors: {
                                                ...this.state.errors,
                                                otp: "Invalid OTP",
                                            },
                                        },
                                        () => {
                                            this.showFormResponse(
                                                false,
                                                "Please correct form errors"
                                            );
                                        }
                                    );
                                } else if (res.status === "invalid otpToken") {
                                    this.showFormResponse(
                                        false,
                                        "Something went wrong! Try resending OTP."
                                    );
                                } else if (res.status === "unverified number") {
                                    this.showFormResponse(
                                        false,
                                        "Number not verified! Try resending OTP."
                                    );
                                } else {
                                    this.showFormResponse(false);
                                }
                            })
                            .catch(err => {
                                this.showFormResponse(
                                    false,
                                    "Something went wrong! Please try again after some time."
                                );
                            });
                    });
                }
            } else {
                this.showFormResponse(false, "Please correct form errors!");
            }
        });
    };

    showFormResponse(success, msg) {
        if (success) {
            this.setState({
                hideSubmit: true,
                submitSpin: false,
                formClass: "success",
                formMsg: msg ? msg : "Form submitted successfully!",
            });
        } else {
            this.setState({
                submitSpin: false,
                formClass: "error",
                formMsg: msg
                    ? msg
                    : "Something went wrong! Please try again after some time.",
            });
        }
    }

    toggleTermsConditions = () => {
        this.setState({
            dialogActive: !this.state.dialogActive,
        });
    };

    clickEvent = e => {
        let target = e.target;
        while (target !== document.body) {
            if (target.classList.contains("multi-select")) {
                if (!this.integrationDrop) {
                    const selectRoot = document.querySelector(
                        ".FormField.integrationPlatform .multi-select"
                    );
                    selectRoot.classList.add("select-active");
                    this.integrationDrop = true;
                }
                return;
            } else if (target.classList.contains("active-result")) {
                this.selectResult(target);
                return;
            } else if (target.classList.contains("close-btn")) {
                this.removeResult(target.parentElement.querySelector("span"));
                return;
            }
            target = target.parentElement;
        }
        if (this.integrationDrop) {
            const selectRoot = document.querySelector(
                ".FormField.integrationPlatform .multi-select"
            );
            selectRoot.classList.remove("select-active");
            this.integrationDrop = false;
        }
    };

    selectResult = target => {
        const val = target.innerText;
        const platforms = this.state.integrationPlatforms;
        platforms.push(val);
        target.classList.remove("active-result");
        target.classList.add("result-selected");
        const errors = this.state.errors;
        errors.integrationPlatforms =
            platforms.length > 0 ? "" : "Please select integration platforms";
        this.setState({
            integrationPlatforms: platforms,
            hideSubmit: false,
            formClass: "error",
            formMsg: this.validateForm(errors) ? "" : this.state.formMsg,
            errors,
        });
    };

    removeResult = target => {
        const val = target.innerText;
        let platforms = this.state.integrationPlatforms;
        platforms = platforms.filter(platform => platform != val);
        const list = document.querySelectorAll(".multi-select .choice-drop li");
        list.forEach(li => {
            if (li.innerText == val) {
                li.classList.remove("result-selected");
                li.classList.add("active-result");
            }
        });
        const errors = this.state.errors;
        errors.integrationPlatforms =
            platforms.length > 0 ? "" : "Please select integration platforms";
        this.setState({
            integrationPlatforms: platforms,
            hideSubmit: false,
            formClass: "error",
            formMsg: this.validateForm(errors) ? "" : this.state.formMsg,
            errors,
        });
    };

    render() {
        const { errors } = this.state;
        const platforms = [];
        this.state.integrationPlatforms.forEach(platform => {
            platforms.push(
                <li className="search-choice" key={platform}>
                    <span>{platform}</span>
                    <a className="close-btn"></a>
                </li>
            );
        });
        return (
            <div className="business-form-container noselect">
                <div className="business-form-container__breadcrumb-nav">
                    <Link to="/">Home</Link>
                    <span>/</span>
                    <Link to="/business-solutions/">Business Solutions</Link>
                    <span>/</span>
                    <Link
                        to="/business-solutions/register/"
                        className="reg-text"
                    >
                        Register
                    </Link>
                </div>
                <h1>Register your business</h1>
                <form
                    className="FormFields"
                    id="business-register-form"
                    noValidate
                    autoComplete="off"
                    onSubmit={e => {
                        e.preventDefault();
                    }}
                >
                    <div
                        className={
                            "FormField" +
                            (errors.businessName.length > 0 ? " invalid" : "")
                        }
                    >
                        <div className="input-container__text">
                            <input
                                type="text"
                                placeholder="Business Name"
                                name="businessName"
                                maxLength="40"
                                value={this.state.businessName}
                                onChange={this.handleChange}
                            />
                            <span className="error_excl">!</span>
                        </div>
                        {errors.businessName.length > 0 && (
                            <span className="error">{errors.businessName}</span>
                        )}
                    </div>
                    <div
                        className={
                            "FormField" +
                            (this.state.solPaymentWebsite ? " redMargBot" : "")
                        }
                    >
                        <p>
                            Please select the business solutions you’re looking
                            for
                        </p>
                        <div className="checkbox-widget checkbox-widget__sol">
                            <label>
                                <input
                                    type="checkbox"
                                    name="solPaymentStore"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>I want to
                                accept payments at my store
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="solPaymentWebsite"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>I want to
                                accept payments on my website/app
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="solSwitch"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>I want to be
                                on PhonePe Switch platform
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="solAdvt"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>I want to
                                advertise on PhonePe
                            </label>
                        </div>
                        {errors.businessSolution.length > 0 && (
                            <span className="error">
                                {errors.businessSolution}
                            </span>
                        )}
                    </div>
                    {this.state.solPaymentWebsite && (
                        <div className="FormField integrationPlatform">
                            <p>Integration Platform</p>
                            <div className="multi-select">
                                <ul className="choices">
                                    {platforms.length > 0 ? (
                                        platforms
                                    ) : (
                                        <input
                                            type="text"
                                            placeholder="Choose integration platform"
                                        />
                                    )}
                                </ul>
                                <div className="choice-drop">
                                    <ul className="select-results">
                                        <li className="active-result">.NET</li>
                                        <li className="active-result">
                                            Android
                                        </li>
                                        <li className="active-result">
                                            CS-Cart
                                        </li>
                                        <li className="active-result">
                                            Flutter
                                        </li>
                                        <li className="active-result">HTML</li>
                                        <li className="active-result">Ionic</li>
                                        <li className="active-result">iOS</li>
                                        <li className="active-result">Java</li>
                                        <li className="active-result">
                                            JavaScript
                                        </li>
                                        <li className="active-result">
                                            Kotlin
                                        </li>
                                        <li className="active-result">
                                            Magento
                                        </li>
                                        <li className="active-result">
                                            Node JS
                                        </li>
                                        <li className="active-result">
                                            OpenCart
                                        </li>
                                        <li className="active-result">PHP</li>
                                        <li className="active-result">
                                            Python
                                        </li>
                                        <li className="active-result">
                                            React Native
                                        </li>
                                        <li className="active-result">Ruby</li>
                                        <li className="active-result">
                                            Shopify
                                        </li>
                                        <li className="active-result">Swift</li>
                                        <li className="active-result">
                                            WooCommerce
                                        </li>
                                        <li className="active-result">
                                            WordPress
                                        </li>
                                        <li className="active-result">
                                            Xamarin
                                        </li>
                                        <li className="active-result">
                                            PrestaShop
                                        </li>
                                        <li className="active-result">
                                            Shiprocket
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {errors.integrationPlatforms.length > 0 && (
                                <span className="error">
                                    {errors.integrationPlatforms}
                                </span>
                            )}
                        </div>
                    )}
                    <div className="FormField physicalStore">
                        <p>Do you have a physical store?</p>
                        <label className="toggle-switch">
                            <input
                                type="checkbox"
                                name="physicalStore"
                                onChange={this.handleChange}
                            />
                            <div className="slider round"></div>
                        </label>
                    </div>
                    {this.state.physicalStore && (
                        <div className="FormField numberOfStore">
                            <div className="field">
                                <p>Number of stores</p>
                                <select
                                    name="numberOfStore"
                                    value={this.state.numberOfStore}
                                    onChange={this.handleChange}
                                >
                                    <option value="" disabled defaultValue>
                                        Choose
                                    </option>
                                    <option value="1">1</option>
                                    <option value="2-5">2 - 5</option>
                                    <option value="6-10">6 - 10</option>
                                    <option value="10+">10+</option>
                                </select>
                            </div>
                            {errors.numberOfStore.length > 0 && (
                                <span className="error">
                                    {errors.numberOfStore}
                                </span>
                            )}
                        </div>
                    )}
                    <div
                        className={
                            "FormField" +
                            (errors.website.length > 0 ? " invalid" : "")
                        }
                    >
                        <div className="input-container__text">
                            <input
                                type="text"
                                placeholder="Do you have a website? Please share the URL"
                                name="website"
                                maxLength="255"
                                value={this.state.website}
                                onChange={this.handleChange}
                            />
                            <span className="error_excl">!</span>
                        </div>
                        {errors.website.length > 0 && (
                            <span className="error">{errors.website}</span>
                        )}
                    </div>
                    <div className="FormField">
                        <p>
                            Nature of Business (please select all that apply to
                            your business)
                        </p>
                        <div className="checkbox-widget checkbox-widget__nature">
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureGrocery"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Grocery
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureFashion"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Fashion &amp; Lifestyle
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureFood"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Food &amp; Beverages
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureHealth"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Healthcare
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureEntertain"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Entertainment
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureTravel"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Travel &amp; Commute
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="natureOthers"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                Others
                            </label>
                        </div>
                        {errors.businessNature.length > 0 && (
                            <span className="error">
                                {errors.businessNature}
                            </span>
                        )}
                    </div>
                    <div className="FormField ordersPerMonth">
                        <div className="field">
                            <p>Approximate Orders per month</p>
                            <select
                                name="ordersPerMonth"
                                value={this.state.ordersPerMonth}
                                onChange={this.handleChange}
                            >
                                <option value="" disabled defaultValue>
                                    Choose
                                </option>
                                <option value="0-1000">0 - 1000</option>
                                <option value="1000-5000">1000 - 5000</option>
                                <option value="5000-20000">5000 - 20000</option>
                                <option value="20000 - 1 lakh">
                                    20000 - 1 Lakh
                                </option>
                                <option value="1 lakh+">1 Lakh+</option>
                            </select>
                        </div>
                        {errors.ordersPerMonth.length > 0 && (
                            <span className="error">
                                {errors.ordersPerMonth}
                            </span>
                        )}
                    </div>
                    <div className="FormField">
                        <p>
                            If you wish to advertise with on PhonePe, please
                            select the ad property you’re interested in.
                        </p>
                        <div className="checkbox-widget checkbox-widget__ads">
                            <label>
                                <input
                                    type="checkbox"
                                    name="brandAds"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                <div>
                                    <p>
                                        <b>Brand Ads</b>
                                    </p>
                                    <p className="label-subtext">
                                        Show your brand &amp; offerings to the
                                        digitally savvy PhonePe users
                                    </p>
                                </div>
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    name="rewardCoupons"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                                <div>
                                    <p>
                                        <b>Reward Coupons</b>
                                    </p>
                                    <p className="label-subtext">
                                        Distribute your offer and cashback
                                        coupons as PhonePe Rewards
                                    </p>
                                </div>
                            </label>
                        </div>
                    </div>
                    <h3>Personal Details</h3>
                    <div
                        className={
                            "FormField" +
                            (errors.name.length > 0 ? " invalid" : "")
                        }
                    >
                        <div className="input-container__text">
                            <input
                                type="text"
                                placeholder="Name"
                                name="name"
                                maxLength="80"
                                value={this.state.name}
                                onChange={this.handleChange}
                            />
                            <span className="error_excl">!</span>
                        </div>
                        {errors.name.length > 0 && (
                            <span className="error">{errors.name}</span>
                        )}
                    </div>
                    <div
                        className={
                            "FormField" +
                            (errors.emailId.length > 0 ? " invalid" : "")
                        }
                    >
                        <div className="input-container__text">
                            <input
                                type="email"
                                placeholder="Email ID"
                                name="emailId"
                                maxLength="80"
                                value={this.state.emailId}
                                onChange={this.handleChange}
                            />
                            <span className="error_excl">!</span>
                        </div>
                        {errors.emailId.length > 0 && (
                            <span className="error">{errors.emailId}</span>
                        )}
                    </div>
                    <div
                        className={
                            "FormField" +
                            (errors.phoneNumber.length > 0 ? " invalid" : "")
                        }
                    >
                        <div className="input-container__text">
                            <input
                                type="text"
                                placeholder="Mobile Number"
                                name="phoneNumber"
                                maxLength="10"
                                value={this.state.phoneNumber}
                                onChange={this.handleChange}
                            />
                            <span className="error_excl">!</span>
                        </div>
                        {errors.phoneNumber.length > 0 && (
                            <span className="error">{errors.phoneNumber}</span>
                        )}
                    </div>
                    <div className="FormField captcha">
                        <GoogleCaptcha
                            type="invisible"
                            siteKey="6LeXBPYZAAAAAFIA9BIb562i9rmufhTb6DO3tVuj"
                            captchaVerifyCallback={this.captchaVerifyCallback}
                            captchaExpiredCallback={this.captchaExpiredCallback}
                            ref={this.GoogleCaptchaRef}
                        />
                        {errors.captcha.length > 0 && (
                            <span className="error">{errors.captcha}</span>
                        )}
                    </div>
                    <div
                        className={
                            "FormField otp" +
                            (errors.otp.length > 0 ? " invalid" : "") +
                            (" " + this.state.otpState)
                        }
                    >
                        <div className="enterOTP">
                            <p>Enter OTP</p>
                            <div className="otp-div">
                                <div className="sticky-div">
                                    <input
                                        type="text"
                                        name="otp"
                                        value={this.state.otp}
                                        maxLength="5"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        {this.state.otpState === "resendOTP" && (
                            <div className="otp-svg">
                                <p>Sending OTP</p>
                                <div className="loading">
                                    <svg viewBox="0 0 24 24">
                                        <circle
                                            className="jss495 jss497"
                                            cx="12"
                                            cy="12"
                                            r="8"
                                            fill="none"
                                            strokeWidth="2"
                                        ></circle>
                                    </svg>
                                </div>
                            </div>
                        )}
                        {this.state.otpState === "correctOTP" && (
                            <p className="correctOTP">Phone number verified</p>
                        )}
                        {errors.otp.length > 0 && (
                            <div className="error_div">
                                <span className="error_excl">!</span>
                                <span className="error">{errors.otp}</span>
                            </div>
                        )}
                        <p className="resendOTP" onClick={this.resendOTP}>
                            resend OTP
                        </p>
                    </div>
                    <div className="FormField tnc">
                        <div className="checkbox-widget">
                            <label>
                                <input
                                    type="checkbox"
                                    name="tnc"
                                    onChange={this.handleChange}
                                />
                                <span className="checkmark"></span>
                            </label>
                            I agree to the&nbsp;
                            <a onClick={this.toggleTermsConditions}>
                                Terms &amp; Conditions
                            </a>
                        </div>
                        {errors.tnc.length > 0 && (
                            <span className="error">{errors.tnc}</span>
                        )}
                    </div>
                    <div
                        className={
                            "dialog_overlay" +
                            (this.state.dialogActive
                                ? " dialog_overlay--active"
                                : "")
                        }
                        style={{ opacity: 0 }}
                    >
                        <div
                            className={
                                "dialog" +
                                (this.state.dialogActive
                                    ? " dialog--active"
                                    : "")
                            }
                        >
                            <div className="dialog__title">
                                Terms &amp; Conditions
                            </div>
                            <div className="dialog__text">
                                I authorize PhonePe to contact me in relation to
                                its product(s) and/or service(s) and permit
                                PhonePe to store my details/information for
                                future communications purposes. I also hereby
                                expressly waive the Do Not Call (DNC)/Do Not
                                Disturb (DND) registrations on my mobile number
                                for contacting me with respect to the same.
                            </div>
                            <div className="dialog__actions">
                                <a onClick={this.toggleTermsConditions}>
                                    <div>Close</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <h3 className={this.state.formClass} id="form-response">
                        {this.state.formMsg}
                    </h3>
                    <div
                        className={
                            "FormField" +
                            (this.state.hideSubmit ? " hidden" : "")
                        }
                        id="submit-btn"
                    >
                        <button
                            type="submit"
                            form="business-register-form"
                            value="Submit"
                            onClick={this.handleSubmit}
                        >
                            {this.state.submitSpin ? (
                                <div
                                    className="loading"
                                    style={{ width: "36px", height: "36px" }}
                                >
                                    <svg viewBox="0 0 24 24">
                                        <circle
                                            className="jss495 jss497"
                                            cx="12"
                                            cy="12"
                                            r="8"
                                            fill="none"
                                            strokeWidth="2"
                                        ></circle>
                                    </svg>
                                </div>
                            ) : this.state.otpState === "hidden" ? (
                                "Send OTP"
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default BusinessForm;
